import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router, } from '@angular/router';
import { faBooks } from '@fortawesome/pro-light-svg-icons';
import { select, Store, } from '@ngrx/store';
import { Cover } from 'app/models/cover';
import { I18NService } from 'app/services/i18-n.service';
import { QueryHelper } from 'core/utils/query-helper';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ResetFacetBubblesAction, UpdateSearchObjectAction } from 'search/actions/facet.actions';
import { SearchResultsReset } from 'search/actions/search.actions';
import { FacetURLFilters } from 'search/facets/models/facet-state';
import { CommonState, } from 'search/full-card/models/card-header';
import { SearchType } from 'search/models/search-type';
import { getIsFirstPage } from 'search/reducers/history.reducer';
import { getLockedFacetsAsQueryParams } from 'search/reducers/root.reducer';
import { resetScrollAndSelectedResourceId } from '../../../../entity/actions/entity.actions';
import {
  AvailabilityStatus,
  AvailabilityUpdateInfo,
  FormatGroup,
  GetItRequest,
  HoldRequest,
  MaterialTab,
} from '../../../../entity/models/entity';
import { ISearchData } from '../../../../models/customization';
import { DictionariesService } from '../../../../services/dictionaries.service';
import { FeatureToggleService } from '../../../../services/feature-toggle.service';

@Component({
  selector: 'app-format-group-card-header',
  templateUrl: './format-group-card-header.component.html',
  styleUrls: ['./format-group-card-header.component.scss'],
})
export class FormatGroupCardHeaderComponent implements OnInit, OnDestroy {
  @Input() public formatGroup: FormatGroup;
  @Output() public getIt$ = new EventEmitter<{ item: GetItRequest }>(true);
  @Output() public placeHold$ = new EventEmitter<{ item: HoldRequest }>(true);
  @ViewChild('header', { static: true }) public header: ElementRef;
  @Output() public tableInited = new EventEmitter();

  public hasPreviousUrl = false;
  public isShowcaseFullPage = false;
  public descriptionVisibilityCondition = false;
  public textInsideDescription: any;
  public sourceDescription: any;
  public fullCardDescriptionUrl = '';
  public coverConfig: Cover;
  public isInnReachSearchAvailable: boolean;
  public searchData: ISearchData;
  public language: string;
  public readonly booksIcon = faBooks;
  public lockedFacetsQueryParams: FacetURLFilters;
  public author: string;
  public title: string;
  public materialType: string;
  public isRapido: boolean = false;
  public isbn: string;
  private readonly subscriptions = new Subscription();

  constructor(
    public router: Router,
    public store: Store<CommonState>,
    private readonly location: Location,
    private readonly route: ActivatedRoute,
    private readonly cdRef: ChangeDetectorRef,
    private i18nService: I18NService,
    private readonly queryHelper: QueryHelper,
    private readonly dictionaryService: DictionariesService
  ) {
  }

  public ngOnInit() {
    this.language = this.i18nService.getLangFacetTitle(this.formatGroup.language);
    this.isbn = this.formatGroup.identifiers?.isbn;
    this.coverConfig = {
      coverUrl: this.formatGroup.coverUrl,
    };
    this.title = this.formatGroup.title;
    this.author = this.formatGroup.primaryAgent?.label;
    this.setDescription(this.formatGroup);
    this.addSubscriptions();
    this.setInnReachSearch(this.formatGroup.materialTabs?.map((tab: MaterialTab) => ({status: tab.availability?.status})));
    this.materialType = this.dictionaryService.getFormatDescriptionByCode(this.formatGroup.materialTabs[0]?.materialTypes?.[0]);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public setInnReachSearch(availabilityUpdates: AvailabilityUpdateInfo[]): void {
    this.isInnReachSearchAvailable = availabilityUpdates
    .some((info: AvailabilityUpdateInfo) => info.status?.general !== AvailabilityStatus.AVAILABLE);

    if (this.isInnReachSearchAvailable) {
      this.searchData = {
        title: this.formatGroup?.title,
        author: this.formatGroup?.primaryAgent?.label,
      };
    }

      this.searchData = {
        title: this.formatGroup?.title,
        author: this.formatGroup?.primaryAgent?.label,
      };
  }

  public onMaterialTypesDataChange(availabilityUpdates: AvailabilityUpdateInfo[]): void {
    this.setInnReachSearch(availabilityUpdates);
  }

  public goToPreviousPage(): void {
    this.location.back();
  }

  public onTableInited(): void {
    this.tableInited.emit();
  }

  public onSeriesTypeSearch(event: KeyboardEvent, seriesTitle: string, seriesTitleSearch: string) {
    const searchText = `"${(seriesTitleSearch || seriesTitle).replace(/"/g, '')}"`;
    const searchType = SearchType.SERIES;
    if (event.key === 'Enter' || event.type === 'click') {
      this.store.dispatch(resetScrollAndSelectedResourceId());
      this.store.dispatch(new SearchResultsReset());
      this.store.dispatch(new UpdateSearchObjectAction({searchParams: {type: {searchText: searchText }}, searchType}));
      this.store.dispatch(new ResetFacetBubblesAction({}));
      const queryParams = this.queryHelper.prepareQueryParams(searchText, this.lockedFacetsQueryParams, searchType);
      this.router.navigate(['/search'], queryParams);
    }
  }

  private addSubscriptions(): void {
    this.subscriptions.add(this.store.pipe(select(getIsFirstPage)).subscribe((isFirstPage: boolean) => {
      this.hasPreviousUrl = !isFirstPage;
    }));

    this.subscriptions.add(this.router.events.pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        setTimeout(() => this.header.nativeElement.focus());
      }),
    );

    this.subscriptions.add(this.route.queryParams.subscribe((params: any) => {
      const showcasesSubrouting = params.showcase;
      this.isShowcaseFullPage = !!showcasesSubrouting;
      const rapido = params.rapido;
      this.isRapido = !!rapido;
      this.cdRef.markForCheck();
    }));

    this.subscriptions.add(this.store.pipe(select(getLockedFacetsAsQueryParams)).subscribe((result) => {
      this.lockedFacetsQueryParams = result;
    }));

  }

  private setDescription(fg: FormatGroup): void {
    if (fg.description) {
      this.descriptionVisibilityCondition = true;
      this.textInsideDescription = fg.description;
      this.sourceDescription = false;
    }
  }
}
